import React, { useContext } from "react";

// Asssets
import signaturerImage from "sass/images/signaturer.jpg";

// External components
// import { useLightbox } from "simple-react-lightbox";
import SimpleReactLightbox, {
    SRLWrapper,
    useLightbox,
} from "simple-react-lightbox";

// Contexts
import { DataContext } from "contexts/Data";
const Signaturer = (props) => {
    const { language, data } = useContext(DataContext);
    const options = {
        settings: { lightboxTransitionSpeed: 0, slideTransitionSpeed: 0 },
    };
    const Comp = ({ images }) => {
        const names = [
            "maria",
            "nazira",
            "saskia",
            "phuong",
            "stine",
            "hiyam",
            "lizbet",
            "lilian",
            "elie_g",
            "carola",
            "signe",
            "heidi",
            "israa_issa",
            "grethe",
            "sophie",
            "susanne",
            "iris",
            "sakhida",
            "andrea",
            "nuri_s",
            "kathrine_g",
            "solveig_h",
            "mette",
            "moity",
            "birgitte",
            "gro",
            "unn_ss",
            "marlena",
            "khetam",
            "kang",
            "katrino_g",
            "augustina",
            "rish",
            "esperanza",
            "namor",
            "helen",
            "nalens_makt_2019",
        ];
        const { openLightbox } = useLightbox();
        const capitalize = (input) => {
            return input
                .toLowerCase()
                .split(" ")
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(" ");
        };
        return (
            <>
                <div>
                    <SRLWrapper options={options}>
                        {names.map((name, index) => (
                            <img
                                style={{ display: "none" }}
                                width="100%"
                                src={
                                    process.env.PUBLIC_URL +
                                    `/images/signaturer/${
                                        index + " " + name
                                    }.jpg`
                                }
                                alt={`${
                                    language === "no" ? "Signaturer" : ""
                                } ${
                                    language === "en" ? "Signatures" : ""
                                } - ${capitalize(name.replace(/_/g, " "))}`}
                            />
                        ))}
                    </SRLWrapper>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 318.1 318.1"
                        className="signaturer"
                    >
                        <defs>
                            <clipPath id="signaturer-clip">
                                <circle cx="159.05" cy="159.05" r="158.7" />
                            </clipPath>
                        </defs>
                        <image
                            href={signaturerImage}
                            clipPath="url(#signaturer-clip)"
                            preserveAspectRatio="xMidYMid slice"
                            x="-0.5%"
                            y="-0.5%"
                            width="101%"
                            height="101%"
                            alt={`Grini ${
                                language === "no" ? "lommetørkle" : ""
                            } ${language === "en" ? "handkerchief" : ""}`}
                        />
                        <g
                            className="signaturer__area"
                            id="maria"
                            onClick={() => openLightbox(names.indexOf("maria"))}
                        >
                            <polygon points="212.84 258.4 186.94 261.31 162.63 259.85 160.52 241.75 182.45 244.4 193.55 241.75 207.29 244.4 212.84 258.4" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="nazira"
                            onClick={() =>
                                openLightbox(names.indexOf("nazira"))
                            }
                        >
                            <polygon points="214.69 253.38 205.17 233.56 237.67 224.84 270.44 221.67 277.31 241.75 239.26 245.19 214.69 253.38" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="saskia"
                            onClick={() =>
                                openLightbox(names.indexOf("saskia"))
                            }
                        >
                            <polyline points="218.91 282.18 212.84 265.54 233.97 251.53 247.19 244.47 264.32 242.93 269.64 253.38 241.24 271.88 218.91 282.18" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="phuong"
                            onClick={() =>
                                openLightbox(names.indexOf("phuong"))
                            }
                        >
                            <polygon points="210.46 287.46 205.17 259.26 186.94 261.31 162.63 259.85 149.16 267.91 160.52 284.03 186.68 290.11 210.46 287.46" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="stine"
                            onClick={() => openLightbox(names.indexOf("stine"))}
                        >
                            <polygon points="262.12 193.7 258.28 212.96 288.4 207.67 285.76 187.85 262.12 193.7" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="hiyam"
                            onClick={() => openLightbox(names.indexOf("hiyam"))}
                        >
                            <polygon points="256.17 170.68 236.62 196.31 249.03 208.46 262.12 193.7 268.32 179.13 256.17 170.68" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="lizbet"
                            onClick={() =>
                                openLightbox(names.indexOf("lizbet"))
                            }
                        >
                            <polygon points="281.8 176.36 268.32 179.13 262.12 174.82 268.85 143.07 285.36 142.28 281.8 176.36" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="lilian"
                            onClick={() =>
                                openLightbox(names.indexOf("lilian"))
                            }
                        >
                            <polygon points="256.17 170.68 265.81 140.56 248.77 139.63 239.65 167.91 256.17 170.68" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="carola"
                            onClick={() =>
                                openLightbox(names.indexOf("carola"))
                            }
                        >
                            <polygon points="246.92 109.64 239.65 121.27 220.76 104.63 206.76 94.06 207.95 81.51 224.06 85.73 246.92 109.64" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="signe"
                            onClick={() => openLightbox(names.indexOf("signe"))}
                        >
                            <polygon points="247.84 118.83 250.62 137.65 218.72 148.75 197.31 142.28 194.34 123.39 239.65 121.27 247.84 118.83" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="heidi"
                            onClick={() => openLightbox(names.indexOf("heidi"))}
                        >
                            <polygon points="198.38 41.21 235.52 64.28 226.53 81.09 189 59.2 198.38 41.21" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="israa_issa"
                            // onClick={() => setModal("israa_issa")}
                            onClick={() =>
                                openLightbox(names.indexOf("israa_issa"))
                            }
                        >
                            <path
                                d="M107.33,38.91s46.13-8.21,47.31-8.6,32.45,7.82,32.45,7.82l-4.7,16.42-29.71-5.48-38.31,8.6Z"
                                transform="translate(0.35 0.35)"
                            />
                        </g>
                        <g
                            className="signaturer__area"
                            id="grethe"
                            onClick={() =>
                                openLightbox(names.indexOf("grethe"))
                            }
                        >
                            <polygon points="79.92 47.47 108.86 55.29 121.76 66.63 117.85 74.44 93.61 65.45 76.41 61.54 79.92 47.47" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="sophie"
                            onClick={() =>
                                openLightbox(names.indexOf("sophie"))
                            }
                        >
                            <polygon points="158.12 51.77 197.21 68.58 191.35 79.53 153.42 61.15 158.12 51.77" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="susanne"
                            onClick={() =>
                                openLightbox(names.indexOf("susanne"))
                            }
                        >
                            <polygon points="92.05 81.09 112.37 74.05 117.85 74.44 123.71 68.19 149.51 54.51 154.6 65.45 95.95 96.73 92.05 81.09" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="iris"
                            onClick={() => openLightbox(names.indexOf("iris"))}
                        >
                            <polygon points="112.37 93.21 138.57 80.7 144.82 92.82 120.97 106.89 112.37 93.21" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="sakhida"
                            onClick={() =>
                                openLightbox(names.indexOf("sakhida"))
                            }
                        >
                            <polygon points="150.3 72.1 196.43 86.17 194.08 97.9 176.1 95.56 144.43 83.44 150.3 72.1" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="andrea"
                            // onClick={() => setModal("andrea")}
                            onClick={() =>
                                openLightbox(names.indexOf("andrea"))
                            }
                        >
                            <polygon points="182.35 110.02 208.55 104.94 221.84 108.85 223.01 115.89 181.96 120.58 182.35 110.02" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="nuri_s"
                            // onClick={() => setModal("nuri_s")}
                            onClick={() =>
                                openLightbox(names.indexOf("nuri_s"))
                            }
                        >
                            <polygon points="225.36 152.63 200.73 180.78 210.11 193.68 235.52 167.49 238.65 160.84 225.36 152.63" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="kathrine_g"
                            onClick={() =>
                                openLightbox(names.indexOf("kathrine_g"))
                            }
                        >
                            <path
                                d="M181.61,217.18c.78-1.17,40.27-26.58,40.27-26.58l11,12.9-44.18,29.71Z"
                                transform="translate(0.35 0.35)"
                            />
                        </g>
                        <g
                            className="signaturer__area"
                            id="solveig_h"
                            onClick={() =>
                                openLightbox(names.indexOf("solveig_h"))
                            }
                        >
                            <path
                                d="M111.63,241.81c-1.95.39-13.29,14.86-13.29,14.86s28.54,39.87,29.71,39.48S150,293,150,293L155,281.69Z"
                                transform="translate(0.35 0.35)"
                            />
                        </g>
                        <g
                            className="signaturer__area"
                            id="mette"
                            onClick={() => openLightbox(names.indexOf("mette"))}
                        >
                            <polygon points="68.59 244.12 101.43 235.12 102.6 246.85 97.91 251.94 70.54 257.41 68.59 244.12" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="birgitte"
                            onClick={() =>
                                openLightbox(names.indexOf("birgitte"))
                            }
                        >
                            <polygon points="50.99 165.53 49.43 174.53 49.82 183.52 57.25 211.28 68.98 205.41 73.67 194.47 65.46 181.56 62.33 181.17 58.42 164.75 50.99 165.53" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="gro"
                            onClick={() => openLightbox(names.indexOf("gro"))}
                        >
                            <path
                                d="M24.45,164.79l24.24,6.65v4.69l.78,7s-25,2.34-25,1.17Z"
                                transform="translate(0.35 0.35)"
                            />
                        </g>
                        <g
                            className="signaturer__area"
                            id="unn_ss"
                            onClick={() =>
                                openLightbox(names.indexOf("unn_ss"))
                            }
                        >
                            <polygon points="77.58 194.47 71.72 210.1 101.04 232.78 110.81 215.58 77.58 194.47" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="elie_g"
                            onClick={() =>
                                openLightbox(names.indexOf("elie_g"))
                            }
                        >
                            <polygon points="267.4 125.89 283.51 122.33 273.34 99.21 251.54 81.51 240.71 95.25 256.3 114.4 267.4 125.89" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="moity"
                            onClick={() => openLightbox(names.indexOf("moity"))}
                        >
                            <path
                                d="M24.45,197.63l14.47-3.12,12.51,39.87S37,239.86,36.57,238.29,24.45,197.63,24.45,197.63Z"
                                transform="translate(0.35 0.35)"
                            />
                        </g>
                        <g
                            className="signaturer__area"
                            id="marlena"
                            onClick={() =>
                                openLightbox(names.indexOf("marlena"))
                            }
                        >
                            <polygon points="150.69 107.28 180.01 97.51 183.92 96.34 194.08 97.9 194.08 104.55 180.01 108.07 178.05 113.15 156.55 116.28 150.69 107.28" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="khetam"
                            onClick={() =>
                                openLightbox(names.indexOf("khetam"))
                            }
                        >
                            <polygon points="143.26 193.68 162.41 189.38 171.41 188.21 194.08 191.34 194.47 203.85 169.45 205.41 151.86 212.84 143.26 193.68" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="kang"
                            onClick={() => openLightbox(names.indexOf("kang"))}
                        >
                            <polygon points="124.1 233.17 152.64 219.49 162.03 232.78 132.7 251.94 124.1 233.17" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="katrino_g"
                            onClick={() =>
                                openLightbox(names.indexOf("katrino_g"))
                            }
                        >
                            <path
                                d="M96.78,156.58l18-5.86,22.68,30.89,9.38,34.4-20.33,9-9.38-38.31L98,164.4Z"
                                transform="translate(0.35 0.35)"
                            />
                        </g>
                        <g
                            className="signaturer__area"
                            id="augustina"
                            onClick={() =>
                                openLightbox(names.indexOf("augustina"))
                            }
                        >
                            <polygon points="80.71 127.61 79.14 149.12 81.1 178.44 95.95 180.39 96.34 163.97 93.22 126.05 80.71 127.61" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="rish"
                            onClick={() => openLightbox(names.indexOf("rish"))}
                        >
                            <polygon points="61.94 144.81 74.84 151.07 72.89 176.48 60.77 171.4 58.81 148.72 61.94 144.81" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="esperanza"
                            onClick={() =>
                                openLightbox(names.indexOf("esperanza"))
                            }
                        >
                            <path
                                d="M75.27,87.78c-2,0-35.57,46.52-35.57,46.52l9.77,10.17,16.81-12.91L85.83,93.64Z"
                                transform="translate(0.35 0.35)"
                            />
                        </g>
                        <g
                            className="signaturer__area"
                            id="namor"
                            onClick={() => openLightbox(names.indexOf("namor"))}
                        >
                            <polygon points="61.94 70.93 72.5 83.44 41.61 117.06 31.06 102.98 61.94 70.93" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="helen"
                            onClick={() => openLightbox(names.indexOf("helen"))}
                        >
                            <polygon points="90.48 93.99 83.83 107.67 101.04 114.32 108.46 117.45 114.72 110.41 104.16 97.12 97.13 98.29 90.48 93.99" />
                        </g>
                        <g
                            className="signaturer__area"
                            id="nalens_makt_2019"
                            onClick={() => {
                                openLightbox(names.indexOf("nalens_makt_2019"));
                            }}
                        >
                            <polygon points="98.3 119.4 108.46 119.4 133.88 108.46 139.35 120.58 176.49 119.4 178.84 132.31 189 133.48 197.21 156.94 202.29 170.62 197.6 188.21 173.75 187.04 147.17 190.16 143.65 168.27 128.4 165.93 121.37 147.16 98.69 150.29 98.3 119.4" />
                        </g>
                    </svg>
                </div>

                <div className="signaturer-text">
                    {data.pages.inspirasjon.signaturer.title[language] && (
                        <h1
                            className="h2"
                            style={{ marginBottom: "2rem", marginTop: "3rem" }}
                        >
                            {data.pages.inspirasjon.signaturer.title[language]}
                        </h1>
                    )}
                    {data.pages.inspirasjon.signaturer.description[
                        language
                    ] && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: data.pages.inspirasjon.signaturer
                                    .description[language],
                            }}
                        ></div>
                    )}
                </div>
            </>
        );
    };
    return (
        <>
            <SimpleReactLightbox>
                <Comp {...props}></Comp>
            </SimpleReactLightbox>
        </>
    );
};

export default Signaturer;
